import { useState } from "react";
import { motion } from "framer-motion";
import { Phone, ChatText, EnvelopeSimple } from "@phosphor-icons/react";

const LINES = ["The next missed call", "is somebody's job.", "Make it yours."];

export const ClosingCta = () => {
  const [revealed, setRevealed] = useState(false);

  return (
  <section id="contact" className="border-t-2 border-line" data-testid="closing-cta-section">
    <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-32">
      <motion.h2
        className="font-display text-4xl font-bold uppercase leading-[1.1] tracking-tighter sm:text-6xl md:text-7xl"
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, margin: "-80px" }}
      >
        {LINES.map((line, i) => (
          <span key={line} className={`-mb-[0.15em] block pb-[0.15em] ${revealed ? "" : "overflow-hidden"}`}>
            <motion.span
              className={`block ${i === 2 ? "text-safety" : ""}`}
              variants={{ hidden: { y: "115%" }, show: { y: 0 } }}
              transition={{ duration: 0.9, delay: i * 0.15, ease: [0.22, 1, 0.36, 1] }}
              onAnimationComplete={i === LINES.length - 1 ? () => setRevealed(true) : undefined}
            >
              {line}
            </motion.span>
          </span>
        ))}
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.5, ease: [0.22, 1, 0.36, 1] }}
        className="mt-8 max-w-2xl text-base leading-relaxed text-gray-300 sm:text-xl"
      >
        Call or text and you'll get Carlo Vescio in Niagara Falls — the guy who sets it up, runs
        it, and picks up when you phone. Not a 1-800 number in Toronto.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.65, ease: [0.22, 1, 0.36, 1] }}
        className="mt-10 flex flex-col gap-4 sm:flex-row"
      >
        <a
          href="tel:+19053517489"
          data-testid="closing-call-button"
          className="flex min-h-[64px] items-center justify-center gap-3 bg-safety px-8 font-display text-xl font-bold uppercase tracking-wide text-asphalt transition-[background-color,transform] duration-200 hover:bg-safetydeep active:translate-y-0.5"
        >
          <Phone weight="bold" className="h-6 w-6" aria-hidden="true" />
          Call 905-351-7489
        </a>
        <a
          href="sms:+19053517489"
          data-testid="closing-text-button"
          className="flex min-h-[64px] items-center justify-center gap-3 border-2 border-safety px-8 font-display text-xl font-bold uppercase tracking-wide text-safety transition-[background-color,color,transform] duration-200 hover:bg-safety hover:text-asphalt active:translate-y-0.5"
        >
          <ChatText weight="bold" className="h-6 w-6" aria-hidden="true" />
          Text 905-351-7489
        </a>
      </motion.div>
      <motion.a
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7, delay: 0.8 }}
        href="mailto:carlo@niagaracallback.ca"
        data-testid="closing-email-link"
        className="mt-8 inline-flex min-h-[48px] items-center gap-3 font-semibold text-safety underline underline-offset-4"
      >
        <EnvelopeSimple weight="bold" className="h-5 w-5" aria-hidden="true" />
        carlo@niagaracallback.ca
      </motion.a>
    </div>
  </section>
  );
};
